import PropTypes from 'prop-types';
import React from 'react';
import TransitionWrapper from 'root/components/molecules/TransitionWrapper';

import OptionsMenu from './optionsMenu';

const OptionsMenuWithTransition = ({
  targetRef,
  visible,
  className,
  onClose,
  options,
  showOnMobile,
  ...props
}) => (
  <TransitionWrapper
    component={OptionsMenu}
    passedProps={{
      className,
      onClose,
      options,
      showOnMobile,
      targetRef,
      ...props,
    }}
    visible={visible}
  />
);

OptionsMenuWithTransition.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      errorStyle: PropTypes.bool,
      onClick: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  showOnMobile: PropTypes.bool,
  targetRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  visible: PropTypes.bool,
};

OptionsMenuWithTransition.defaultProps = {
  className: '',
  options: [],
  showOnMobile: true,
  visible: false,
};

export default OptionsMenuWithTransition;
